export const GET_MY_IDEAS_SUCCESS = "GET_MY_IDEAS_SUCCESS";
export const CREATE_IDEA_SUCCESS = "CREATE_IDEA_SUCCESS";
export const EDIT_IDEA_SUCCESS = "EDIT_IDEA_SUCCESS";
export const DELETE_IDEA_SUCCESS = "DELETE_IDEA_SUCCESS";
export const REJECT_IDEA_SUCCESS = "REJECT_IDEA_SUCCESS";
export const ACCEPT_IDEA_SUCCESS = "ACCEPT_IDEA_SUCCESS";
export const SOCKET_IO_IDEA_UPDATE = "SOCKET_IO_IDEA_UPDATE";
